<div class="textarea-wrapper">
  <textarea
    #textarea
    [value]="value"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [attr.readonly]="readonly ? '' : null"
    [rows]="rows"
    [class.no-resize]="!resize"
    (input)="onInput($event)">
  </textarea>
</div>
